<template>
    <v-card elevation="0">
        <v-tabs v-model="tab" centered icons-and-text background-color="transparent" color="#8FB3A3">
        <v-tabs-slider></v-tabs-slider>
            <v-tab>
                Upload
                <v-icon>mdi-upload</v-icon>
            </v-tab>
            <v-tab>
                Net Bills
                <v-icon>mdi-file-multiple</v-icon>
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <UploadFile />
            </v-tab-item>
            <v-tab-item>
                <NetBills />
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>
<script>
import UploadFile from "./UploadFile.vue"
import NetBills from "./NetBills.vue"

export default {
    components: {
        UploadFile,
        NetBills
    },
    data(){
        return {
            tab: null
        }
    }
}
</script>